export interface ServerSelectOption {
  label: string
  value: number | string
  disabled?: boolean
}
